export default __webpack_public_path__ + "static/media/LogoSVG.718e8d70.svg";